exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(/assets/customfonts/style.css);", ""]);

// module
exports.push([module.id, "\n#app {\n  font-family:\"SF Light\";\n  background-color: #f2f2f2;\n  height: 100vh;\n}\nhtml, body {\n    overflow: hidden;\n}\n\n", ""]);

// exports
